import React, { useState } from "react";
import { ImagePlus } from "lucide-react";
import { MediaPickerModal } from "./MediaManager";

// Normalize field value for editing
function valueToInput(field, value) {
  if (value == null) return field.type === "bool" ? false : field.type === "number" ? 0 : "";
  if (field.type === "csv") return Array.isArray(value) ? value.join(", ") : value;
  if (field.type === "list") return Array.isArray(value) ? value.join("\n") : value;
  return value;
}

function inputToValue(field, value) {
  if (field.type === "csv") return String(value).split(",").map((s) => s.trim()).filter(Boolean);
  if (field.type === "list") return String(value).split("\n").map((s) => s.trim()).filter(Boolean);
  if (field.type === "number") return Number(value || 0);
  if (field.type === "bool") return Boolean(value);
  return value;
}

export default function Field({ field, value, onChange }) {
  const id = `fld-${field.name}`;
  const [pickerOpen, setPickerOpen] = useState(false);
  const common = {
    id,
    value: valueToInput(field, value),
    onChange: (e) => onChange(inputToValue(field, field.type === "bool" ? e.target.checked : e.target.value)),
    "data-testid": `admin-input-${field.name}`
  };

  if (field.type === "textarea")
    return (
      <div>
        <label className="overline block mb-1" htmlFor={id}>{field.label}{field.required && <span className="text-volt"> *</span>}</label>
        <textarea rows={4} {...common} />
      </div>
    );
  if (field.type === "list")
    return (
      <div>
        <label className="overline block mb-1" htmlFor={id}>{field.label}</label>
        <textarea rows={4} {...common} />
      </div>
    );
  if (field.type === "select")
    return (
      <div>
        <label className="overline block mb-1" htmlFor={id}>{field.label}</label>
        <select {...common}>
          {field.options.map((o) => <option key={o} value={o}>{o}</option>)}
        </select>
      </div>
    );
  if (field.type === "bool")
    return (
      <label className="flex items-center gap-3 cursor-pointer text-fog-200" htmlFor={id}>
        <input id={id} type="checkbox" checked={!!value} onChange={common.onChange} className="w-4 h-4 accent-volt" data-testid={`admin-input-${field.name}`} />
        <span>{field.label}</span>
      </label>
    );
if (field.type === "image")
    return (
      <div>
        <label className="overline block mb-1" htmlFor={id}>{field.label}{field.required && <span className="text-volt"> *</span>}</label>
        <div className="flex gap-2">
          <input type="text" {...common} placeholder={field.placeholder || "Upload or paste an image URL"} />
          <button
            type="button"
            className="btn-ghost shrink-0"
            onClick={() => setPickerOpen(true)}
            data-testid={`admin-browse-${field.name}`}
          >
            <ImagePlus className="w-4 h-4" /> Browse
          </button>
        </div>
        {value && (
          <img src={value} alt="" className="mt-2 h-20 w-auto rounded border border-white/10 object-cover" />
        )}
        <MediaPickerModal
          open={pickerOpen}
          onClose={() => setPickerOpen(false)}
          onSelect={(url) => { onChange(url); setPickerOpen(false); }}
        />
      </div>
    );
  if (field.type === "number")
    return (
      <div>
        <label className="overline block mb-1" htmlFor={id}>{field.label}</label>
        <input type="number" {...common} />
      </div>
    );
  return (
    <div>
      <label className="overline block mb-1" htmlFor={id}>{field.label}{field.required && <span className="text-volt"> *</span>}</label>
      <input type="text" {...common} placeholder={field.placeholder} />
    </div>
  );
}

export { valueToInput, inputToValue };
